import { useCallback, useState } from "react";

import { useCheckReceivalPermissions } from "@hooks/actions/useCheckReceivalPermissions";
import { RenewalWithCheckReceivalFragment } from "@covertree/agent-portal-graphql";

export function useRenewalCheckReceivalAction() {
  const [renewal, setRenewal] = useState<RenewalWithCheckReceivalFragment>();
  const [markAsPaidOpen, setMarkAsPaidOpen] = useState(false);
  const [markAsUnpaidOpen, setMarkAsUnpaidOpen] = useState(false);

  const { isRenewalMarkable } = useCheckReceivalPermissions();

  const showMarkAsPaidModal = useCallback(
    (renewal: RenewalWithCheckReceivalFragment) => {
      if (!isRenewalMarkable) {
        return;
      }
      setRenewal(renewal);
      setMarkAsPaidOpen(true);
    },
    [isRenewalMarkable]
  );

  const showMarkAsUnpaidModal = useCallback(
    (renewal: RenewalWithCheckReceivalFragment) => {
      if (!isRenewalMarkable || !renewal.checkReceival) {
        return;
      }
      setRenewal(renewal);
      setMarkAsUnpaidOpen(true);
    },
    [isRenewalMarkable]
  );

  const closeModal = useCallback(() => {
    setMarkAsUnpaidOpen(false);
    setMarkAsPaidOpen(false);
    setRenewal(undefined);
  }, []);

  return {
    markAsPaidOpen,
    markAsUnpaidOpen,
    renewalToManageCheckReceival: renewal,
    showMarkAsPaidModal,
    showMarkAsUnpaidModal,
    closeRenewalCheckReceivalModal: closeModal,
  };
}
